import { useState, ReactNode } from 'react'

interface CollapsibleQuestionProps {
  title: string
  children: ReactNode
}

export default function CollapsibleQuestion({
  title,
  children,
}: CollapsibleQuestionProps) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="w-full">
      <button
        className="w-full py-[10px] flex justify-between items-center focus:outline-none border-b border-gray-200 mb-[10px]"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h2 className="text-18 font-semibold text-left mr-20">{title}</h2>
        <span className="text-2xl">{isOpen ? '-' : '+'}</span>
      </button>
      {isOpen && <div className="pb-10">{children}</div>}
    </div>
  )
}
